const LOAD_JOBS_APPLIED_LIST_APPLICANT           = 'LOAD_JOBS_APPLIED_LIST_APPLICANT'
const LOAD_JOBS_APPLIED_LIST_APPLICANT_SUCCESS   = 'LOAD_JOBS_APPLIED_LIST_APPLICANT_SUCCESS'
const LOAD_JOBS_APPLIED_LIST_APPLICANT_FAILED    = 'LOAD_JOBS_APPLIED_LIST_APPLICANT_FAILED'
const UNMOUNT_JOBS_APPLIED_LIST_APPLICANT        = 'UNMOUNT_JOBS_APPLIED_LIST_APPLICANT'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const jobsAppliedReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_JOBS_APPLIED_LIST_APPLICANT:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_JOBS_APPLIED_LIST_APPLICANT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_JOBS_APPLIED_LIST_APPLICANT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_JOBS_APPLIED_LIST_APPLICANT:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default jobsAppliedReducer;